import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import {
    Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
    Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField, Typography, Menu, ListItemIcon, ListItemText, Pagination, Checkbox
  } from '@mui/material';
import { ExpandMore, ExpandLess, Search, History, MoreVert, Add, Edit } from '@mui/icons-material';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import RoomIcon from "@mui/icons-material/Room";
import MuiAlert from '@mui/material/Alert';
import HistoriqueModal from './HistoriqueModal';
import DeleteIcon from '@mui/icons-material/Delete';
import AddModal from './AddModal';
import UpdateModal from './UpdateModal';



export default function PickupTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);

  const [openadd, setOpenAdd] = useState(false);
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  const [openupd, setOpenUpd] = useState(false);
  const handleOpenUpd = () => setOpenUpd(true);
  const handleCloseUpd = () => setOpenUpd(false);
  
  // State for data
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [trajets, setTrajets] = useState([]);
  const [selectedPickup, setSelectedPickup] = useState(null);




  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };

  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  
  // State for selected rows/checkboxes
  const [selected, setSelected] = useState([]);
  const [groupAction, setGroupAction] = useState('');
  
  // Search states
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchTrajet, setSearchTrajet] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  
  // Fetch pickups from API
  const fetchPickups = async () => {
    try {
      setLoading(true);
      const response = await api.get('/pickups');
      setRows(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching pickups:', error);
      handleSnack('Erreur lors du chargement des points de ramassage', 'error');
      setLoading(false);
    }
  };
  
  // Fetch trajets from API
  const fetchTrajets = async () => {
    try {
      const response = await api.get('/trajets');
      setTrajets(response.data);
    } catch (error) {
      console.error('Error fetching trajets:', error);
    }
  };
  
  // Load data on component mount
  useEffect(() => {
    fetchPickups();
    fetchTrajets();
  }, []);

  const handleDelete = async () => {
    try {
      if (menuRowId) {
        await api.delete(`/pickups/${menuRowId}`);
        handleSnack('Point de ramassage supprimé avec succès', 'success');
        fetchPickups(); // Refresh the list
      }
      handleMenuClose();
    } catch (error) {
      console.error('Error deleting pickup:', error);
      
      // Handle different types of errors
      if (error.response) {
        const { status } = error.response;
        
        // Handle not found error
        if (status === 404) {
          handleSnack("Le point de ramassage n'existe pas ou a déjà été supprimé", "error");
        }
        // Handle forbidden error
        else if (status === 403) {
          handleSnack("Vous n'avez pas les droits nécessaires pour supprimer ce point de ramassage", "error");
        }
        // Handle server error
        else if (status === 500) {
          handleSnack("Une erreur serveur s'est produite. Veuillez réessayer plus tard", "error");
        }
        // Handle other errors
        else {
          handleSnack("Erreur lors de la suppression du point de ramassage", "error");
        }
      } else {
        // Handle network errors
        handleSnack("Problème de connexion au serveur. Veuillez vérifier votre connexion internet", "error");
      }
      handleMenuClose();
    }
  };

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
    
    // Find the selected pickup for update modal
    const pickup = rows.find(row => row.id_pickup === id);
    setSelectedPickup(pickup);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map(n => n.id_pickup);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleGroupAction = async () => {
    if (groupAction === 'Supprimer' && selected.length > 0) {
      try {
        // Use Promise.allSettled to track success/failure of each deletion
        const deletePromises = selected.map(id => 
          api.delete(`/pickups/${id}`)
            .then(() => ({ id, status: 'fulfilled' }))
            .catch(error => ({ id, status: 'rejected', error }))
        );
        
        const results = await Promise.all(deletePromises);
        
        // Count successes and failures
        const successCount = results.filter(r => r.status === 'fulfilled').length;
        const failureCount = selected.length - successCount;
        
        // Prepare appropriate message based on results
        if (successCount === selected.length) {
          handleSnack(`${successCount} points de ramassage supprimés avec succès`, "success");
        } else if (successCount > 0) {
          handleSnack(`${successCount} points de ramassage supprimés, ${failureCount} échecs`, "warning");
        } else {
          handleSnack("Échec de la suppression des points de ramassage", "error");
        }
        
        setSelected([]);
        setGroupAction('');
        fetchPickups(); // Refresh the list
      } catch (error) {
        console.error('Error deleting pickups:', error);
        
        // Handle different types of errors
        if (error.response && error.response.status === 500) {
          handleSnack("Une erreur serveur s'est produite. Veuillez réessayer plus tard", "error");
        } else {
          handleSnack("Erreur lors de la suppression des points de ramassage", "error");
        }
      }
    }
  };
  
  // Handle search
  const handleSearch = () => {
    // Search is handled by the filteredRows computation
  };
  
  // Handle reset search
  const handleReset = () => {
    setSearchKeyword('');
    setSearchTrajet('');
    setSearchStatus('');
  };

  // Filter rows based on search criteria
  const filteredRows = rows.filter(row => {
    const matchesKeyword = searchKeyword ? 
      row.name?.toLowerCase().includes(searchKeyword.toLowerCase()) : true;
    
    const matchesTrajet = searchTrajet ? 
      row.ID_Trajet === parseInt(searchTrajet) : true;
    
    const matchesStatus = searchStatus ? 
      row.Status?.toLowerCase() === searchStatus.toLowerCase() : true;
    
    return matchesKeyword && matchesTrajet && matchesStatus;
  });
  
  const paginatedRows = filteredRows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(filteredRows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <RoomIcon />
            <Typography variant="h6"> POINTS DE RAMASSAGE</Typography>
          </Box>
          <Box display="flex" gap={2}>
            <Button variant="outlined"
             onClick={handleOpenAdd}
            sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
            }} startIcon={<Add />}>Ajouter</Button>
          </Box>
        </Box>
          {/* Search Section */}
          <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>

        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
            <TextField
                label="Mot cle"
                InputLabelProps={{ shrink: true }}
                fullWidth size="small"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  }
                }}
              />
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Trajet</InputLabel>
                <Select 
                  label="Trajet"
                  value={searchTrajet}
                  onChange={(e) => setSearchTrajet(e.target.value)}
                >
                  <MenuItem value="">Tous</MenuItem>
                  {trajets.map((trajet) => (
                    <MenuItem key={trajet.ID_Trajet} value={trajet.ID_Trajet}>
                      {trajet.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Direction</InputLabel>
                <Select label="Trajet">
                  <MenuItem value="Direction 1">Direction 1</MenuItem>
                  <MenuItem value="Direction 2">Direction 2</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Statut</InputLabel>
                <Select 
                  label="Statut"
                  value={searchStatus}
                  onChange={(e) => setSearchStatus(e.target.value)}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="Active">Actif</MenuItem>
                  <MenuItem value="inactive">Inactif</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button 
                variant="outlined" 
                onClick={handleReset}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Reset
              </Button>
              <Button 
                variant="outlined" 
                onClick={handleSearch}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Search
              </Button>
            </Box>
          </Paper>
        </Collapse>


        {/* Bulk Actions */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography>Actions groupées</Typography>
            <FormControl size="small" sx={{
                minWidth: 150 ,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
              <Select
                value={groupAction}
                onChange={(e) => setGroupAction(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled><em>Sélectionner</em></MenuItem>
                <MenuItem value="Supprimer">Supprimer</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              disabled={!groupAction || selected.length === 0}
              onClick={handleGroupAction}
              sx={{
                bgcolor: 'red',
                textTransform: 'none',
                '&:hover': { bgcolor: 'red' },
                '&.Mui-disabled': { bgcolor: '#f5f5f5', color: '#bdbdbd' }
              }}
            >
              Appliquer
            </Button>
          </Box>
          <Typography>{selected.length} sélectionnés / {filteredRows.length} entrées</Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={selected.length > 0 && selected.length < rows.length}
                        checked={rows.length > 0 && selected.length === rows.length}
                        onChange={handleSelectAll}
                        sx={{
                        '&.MuiCheckbox-indeterminate': { color: '#000' },
                        '&.Mui-checked': { color: '#000' },
                        }}
                    />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Trajet</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>État</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {paginatedRows.map((row) => {
                    const isItemSelected = isSelected(row.id_pickup);
                    return (
                    <TableRow key={row.id_pickup} hover selected={isItemSelected}>
                        <TableCell padding="checkbox">
                        <Checkbox
                            checked={isItemSelected}
                            onChange={(event) => handleSelectOne(event, row.id_pickup)}
                            sx={{
                            '&.MuiCheckbox-indeterminate': { color: '#000' },
                            '&.Mui-checked': { color: '#000' },
                            }}
                        />
                        </TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.trajet?.name}</TableCell>
                        <TableCell>
                        <Box
                            sx={{
                            backgroundColor: row.Status === 'active' || row.Status === 'Active' ? '#4caf50' : '#dc3545',
                            color: 'white',
                            borderRadius: '4px',
                            px: 1,
                            py: 0.5,
                            display: 'inline-block',
                            fontSize: '0.8rem',
                            textAlign: 'center',
                            minWidth: '60px',
                            }}
                        >
                            {row.Status === 'active' || row.Status === 'Active' ? 'Actif' : 'Inactif'}
                        </Box>
                        </TableCell>
                        <TableCell>
                        <IconButton onClick={(e) => handleMenuClick(e, row.id_pickup)}>
                            <MoreVert />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={menuRowId === row.id_pickup && openMenu}
                            onClose={handleMenuClose}
                            PaperProps={{
                            sx: {
                                minWidth: '200px',
                                '& .MuiMenuItem-root': {
                                color: 'black',
                                '& .MuiListItemIcon-root': { color: 'black' },
                                '&:hover': {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    '& .MuiListItemIcon-root': { color: 'white' },
                                },
                                },
                            },
                            }}
                        >
                            <MenuItem onClick={handleOpenUpd}>
                            <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                            <ListItemText>Modifier</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleOpenHis}>
                            <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                            <ListItemText>Historique</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleDelete}>
                            <ListItemIcon sx={{ color: 'red' }}><DeleteIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Supprimer</ListItemText>
                            </MenuItem>
                        </Menu>
                        </TableCell>
                    </TableRow>
                    );
                })}
                </TableBody>
            </Table>
         </TableContainer>
        {/* Pagination */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{filteredRows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>

      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>

    <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
    <AddModal 
      open={openadd} 
      handleClose={handleCloseAdd} 
      handleSnack={handleSnack} 
      onSuccess={fetchPickups} 
      trajets={trajets}
    />
    <UpdateModal 
      open={openupd} 
      handleClose={handleCloseUpd} 
      handleSnack={handleSnack} 
      onSuccess={fetchPickups} 
      selectedRow={selectedPickup}
      trajets={trajets}
    />
    </Box>
  );
}